module.exports = __webpack_public_path__ + "img/dresscode.4fa4b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dresscode.png
// module id = 1093
// module chunks = 0